export const QUESTIONS = [
  // ── Section 1: The Pain ──────────────────────────────────────────────────
  {
    id: "q1",
    section: "The Pain",
    sectionKey: "pain",
    sectionColor: "#9498D4",
    sectionIcon: "local_fire_department",
    text: "What's the biggest challenge your organization faces right now?",
    subtitle: null,
    answers: [
      { text: "We know we need to modernize but don't know where to start", score: 1 },
      { text: "We're spending too much time on repetitive work and not enough on growth", score: 2 },
      { text: "We're growing but our operations can't keep up", score: 3 },
      { text: "We're stretched thin and burning out", score: 4 },
    ],
  },
  {
    id: "q2",
    section: "The Pain",
    sectionKey: "pain",
    sectionColor: "#9498D4",
    sectionIcon: "local_fire_department",
    text: "How many hours per week are spent on repetitive, manual tasks in your organization?",
    subtitle: "Think: data entry, document assembly, scheduling, follow-ups, report pulling",
    answers: [
      { text: "Less than 5 hours", score: 1 },
      { text: "5–10 hours", score: 2 },
      { text: "10–20 hours", score: 3 },
      { text: "More than 20 hours", score: 4 },
    ],
  },
  {
    id: "q3",
    section: "The Pain",
    sectionKey: "pain",
    sectionColor: "#9498D4",
    sectionIcon: "local_fire_department",
    text: "When your organization gets busier, what happens first?",
    subtitle: null,
    answers: [
      { text: "It gets absorbed — things just take a little longer", score: 1 },
      { text: "Quality starts to slip — things fall through the cracks", score: 2 },
      { text: "We hit a wall — taking on more requires adding capacity", score: 3 },
      { text: "We're already past the wall — we're turning away work or burning out", score: 4 },
    ],
  },

  // ── Section 2: AI Familiarity ─────────────────────────────────────────────
  {
    id: "q4",
    section: "AI Familiarity",
    sectionKey: "familiarity",
    sectionColor: "#2AC0D0",
    sectionIcon: "psychology",
    text: "How would you describe your organization's familiarity with AI tools?",
    subtitle: "Tools like ChatGPT, Claude, Gemini, or other AI assistants",
    answers: [
      { text: "We haven't really used them", score: 1 },
      { text: "We've done some experimenting, but nothing organized", score: 2 },
      { text: "We use them regularly for specific tasks like writing or research", score: 3 },
      { text: "We've integrated AI tools into our workflow", score: 4 },
    ],
  },
  {
    id: "q5",
    section: "AI Familiarity",
    sectionKey: "familiarity",
    sectionColor: "#2AC0D0",
    sectionIcon: "psychology",
    text: "How would you describe prompt-writing skill in your organization?",
    subtitle: "Giving AI clear instructions to get useful, consistent results",
    answers: [
      { text: "Low — we wouldn't really know where to start", score: 1 },
      { text: "Inconsistent — some prompts perform well; others don't", score: 2 },
      { text: "Solid — we're comfortable prompting AI tools", score: 3 },
      { text: "Strong — we have internal guidelines or practices around it", score: 4 },
    ],
  },
  {
    id: "q6",
    section: "AI Familiarity",
    sectionKey: "familiarity",
    sectionColor: "#2AC0D0",
    sectionIcon: "psychology",
    text: "Has your organization established how AI should and shouldn't be used?",
    subtitle: null,
    answers: [
      { text: "No — we haven't had that conversation yet", score: 1 },
      { text: "Informally — there are opinions but nothing documented", score: 2 },
      { text: "We've discussed it but haven't formalized anything", score: 3 },
      { text: "Yes — we have guidelines or policies around AI use", score: 4 },
    ],
  },

  // ── Section 3: Clarity of Opportunity ────────────────────────────────────
  {
    id: "q7",
    section: "Clarity of Opportunity",
    sectionKey: "clarity",
    sectionColor: "#2AC0D0",
    sectionIcon: "my_location",
    text: "How would you describe your key business processes?",
    subtitle: "Things like client onboarding, service delivery, invoicing, reporting",
    answers: [
      { text: "They mostly live in people's heads — we figure it out as we go", score: 1 },
      { text: "Some documented, some not — it depends on context", score: 2 },
      { text: "Most are documented or standardized — people follow a consistent process", score: 3 },
      { text: "They're well-defined and we know exactly where the bottlenecks are", score: 4 },
    ],
  },
  {
    id: "q8",
    section: "Clarity of Opportunity",
    sectionKey: "clarity",
    sectionColor: "#2AC0D0",
    sectionIcon: "my_location",
    text: "How confident are you that you could name the three tasks where AI could save the most time?",
    subtitle: "Think: specific workflows, not general ideas",
    answers: [
      { text: "Not confident — I know things are inefficient but I'm not sure where exactly", score: 1 },
      { text: "Somewhat — I could guess, but I haven't mapped it out", score: 2 },
      { text: "Fairly confident — I have a good sense of where time is being wasted", score: 3 },
      { text: "Very confident — I know exactly which processes need to change", score: 4 },
    ],
  },
  {
    id: "q9",
    section: "Clarity of Opportunity",
    sectionKey: "clarity",
    sectionColor: "#2AC0D0",
    sectionIcon: "my_location",
    text: "Where does your important business data live?",
    subtitle: null,
    answers: [
      { text: "Scattered — some in email, some in spreadsheets, some in people's heads", score: 1 },
      { text: "Mostly in a few tools, but nothing talks to each other", score: 2 },
      { text: "In organized systems, but we still do a lot of manual transfer between them", score: 3 },
      { text: "In connected systems with mostly clean, accessible data", score: 4 },
    ],
  },

  // ── Section 4: What You Need (routing signals) ────────────────────────────
  {
    id: "q10",
    section: "What You Need",
    sectionKey: "whatYouNeed",
    sectionColor: "#2AC0D0",
    sectionIcon: "explore",
    text: "Which of these sounds most like what you need right now?",
    subtitle: null,
    answers: [
      { text: "Help my organization understand what AI can do", score: 0, needRoute: "training" },
      { text: "Figure out where AI would have the biggest impact in our operations", score: 0, needRoute: "audit" },
      { text: "Build a specific tool or automation we already have in mind", score: 0, needRoute: "build" },
      { text: "I'm not sure — I need to talk through it", score: 0, needRoute: "discovery" },
    ],
  },
  {
    id: "q11",
    section: "What You Need",
    sectionKey: "whatYouNeed",
    sectionColor: "#2AC0D0",
    sectionIcon: "explore",
    text: "What kind of AI solution interests you most?",
    subtitle: null,
    answers: [
      { text: "Simple automations — scheduling, follow-ups, document generation", score: 2, buildTier: 1 },
      { text: "An AI assistant or chatbot for my team or my customers", score: 3, buildTier: 2 },
      { text: "A custom application or internal tool built around AI", score: 4, buildTier: 3 },
      { text: "I don't know enough yet to answer this question", score: 1, buildTier: 0 },
    ],
  },
  {
    id: "q12",
    section: "What You Need",
    sectionKey: "whatYouNeed",
    sectionColor: "#2AC0D0",
    sectionIcon: "explore",
    text: "What impact from AI would matter most to your organization?",
    subtitle: null,
    answers: [
      { text: "Reclaiming hours lost to repetitive work", score: 0, valueFocus: "time_back" },
      { text: "Producing more output with the same people", score: 0, valueFocus: "leverage" },
      { text: "Raising the quality of the work we do", score: 0, valueFocus: "quality" },
      { text: "Growing without hiring", score: 0, valueFocus: "scale" },
    ],
  },

  // ── Section 5: Ready to Act ───────────────────────────────────────────────
  {
    id: "q13",
    section: "Ready to Act",
    sectionKey: "readiness",
    sectionColor: "#6B91FF",
    sectionIcon: "bolt",
    text: "How soon are you looking to take action?",
    subtitle: null,
    answers: [
      { text: "Right now — this is urgent", score: 4 },
      { text: "In the next 1–3 months", score: 3 },
      { text: "In the next 3–6 months", score: 2 },
      { text: "I'm just exploring for now", score: 1 },
    ],
  },
  {
    id: "q14",
    section: "Ready to Act",
    sectionKey: "readiness",
    sectionColor: "#6B91FF",
    sectionIcon: "bolt",
    text: "Who makes the decision about investments like this?",
    subtitle: null,
    answers: [
      { text: "I do — it's my call", score: 4 },
      { text: "I do, with input from others", score: 3 },
      { text: "I'd need approval from leadership or a board", score: 2 },
      { text: "I'm researching for someone else", score: 1 },
    ],
  },
];
